// import Vue from "vue";
// import Vuex from "vuex";
import mutations from "./actions/mutations";
import actions from "./actions/actions";
import getters from "./actions/getters";
import createPersistedState from "vuex-persistedstate";
import storage from '@/utils/storage';
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const state = () => ({
  loadedLanguages: [],
  depositMoney: 0,
  platform: 3,
  uriParams: {},
  user: storage.getLocal('login-token') || {
    country: "ke"
  },
  cardList: [],
  bankList: [],
  tabList: [],
  amountList: [], // 充值可选金额列表
  backEeventStatus: false,
  firstBonusStatus: 0,
  firstBonusInfo: 0,
  firstBonusRate: 0,
  lang: 'sw',
  loadedLanguages: [],
  max: 999999999,
  min: 0,
  depositResult: null,
  withdrawResult: null,
  depositGiftStatus: false,
  depositGiftList: [
    // { giftMoney: 200, moneyMin: 20, moneyMax: 3000, coupons: null }
    // ,
    // { giftMoney: 400, moneyMin: 3001, moneyMax: 5000, coupons: null }
    // ,
    // { giftMoney: 10000600, moneyMin: 5001, moneyMax: 10000000, coupons: null }
  ],
  depositGiftRate: 0,
});

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {},
  strict: debug,
  plugins: [
    createPersistedState({
      key: "bangpayPersisted",
      storage: window.localStorage,
      reducer(data) {
        return {
          user: data.user,
          platform: data.platform,
          uriParams: data.uriParams,
          amountList: data.amountList
        };
      }
    })
  ]
});



// WEBPACK FOOTER //
// ./src/store/index.js